import { useTranslation } from "react-i18next";
import type { LiveStream } from "@/types";
import { formatDuration } from "@/utils/dateFormat";

interface LiveStreamEndedSummaryProps {
  /** The stream attempt to summarize, if any */
  stream?: LiveStream | null;
  /** pages-namespace i18n key shown when both startedAt and endedAt exist */
  messageKey: string;
  className?: string;
  fallbackClassName?: string;
}

export default function LiveStreamEndedSummary({
  stream,
  messageKey,
  className = "text-sm text-secondary-500",
  fallbackClassName = "text-sm text-secondary-500",
}: LiveStreamEndedSummaryProps) {
  const { t } = useTranslation(["pages"]);

  if (stream?.endedAt && stream?.startedAt) {
    const durationMs =
      new Date(stream.endedAt).getTime() - new Date(stream.startedAt).getTime();
    const endedAtFormatted = new Date(stream.endedAt).toLocaleTimeString(
      undefined,
      {
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h23",
      },
    );
    return (
      <p className={className}>
        {t(messageKey, {
          ns: "pages",
          endedAt: endedAtFormatted,
          duration: formatDuration(durationMs),
        })}
      </p>
    );
  }

  return (
    <p className={fallbackClassName}>
      {t("sessions.detail.liveStream.unavailableFallback", { ns: "pages" })}
    </p>
  );
}
